import { getIntl } from '../../../../../../../utils/intl';

const messages = {
    activeMedicationsNegativeSideEffects: 'Share any potential side effects of current medications.',
    changesToMedications: 'Explain any recent changes to medications.',
    upcomingVisits: 'List any upcoming visits and who they are with.',
    activeConditions: 'List any active conditions and corresponding medications.',
    summarize6Months: 'Summarize the last 6 months of activity for a medical professional.',
    followupTasks: 'Are there any tasks or procedures to follow up with?',
} as const;

export const suggestionsIntl = getIntl('chatSuggestions', messages);

export const suggestions = Object.keys(messages) as (keyof typeof messages)[];
